import { combineReducers } from 'redux';

import billingReducer from './billing/reducer';
import candidatesReducer from './candidates/reducer';
import employersReducer from './employers/reducer';
import grantsReducer from './grants/reducer';
import groupSearchReducer from './groupSearch/reducer';
import hiringEventReducer from './hiringEvent/reducer';
import hubsReducer from './hubs/reducer';
import jobCampaignsReducer from './jobCampaigns/reducer';
import jobGroupsReducer from './jobGroups/reducer';
import jobsReducer from './jobs/reducer';
import registrantsReducer from './registrants/reducer';
import resumeManagementReducer from './resumeManagement/reducer';
import settingsReducer from './settings/reducer';
import subOrganizationsReducer from './subOrganizations/reducer';
import dashboardReducer from './dashboard/reducer';

export default combineReducers({
  billing: billingReducer,
  candidates: candidatesReducer,
  employers: employersReducer,
  grants: grantsReducer,
  groupSearch: groupSearchReducer,
  hiringEvent: hiringEventReducer,
  hubs: hubsReducer,
  jobCampaigns: jobCampaignsReducer,
  jobGroups: jobGroupsReducer,
  jobs: jobsReducer,
  registrants: registrantsReducer,
  resumeManagement: resumeManagementReducer,
  settings: settingsReducer,
  subOrganizations: subOrganizationsReducer,
  dashboard: dashboardReducer,
});
